import { Action, createReducer } from '@reduxjs/toolkit';

import { type PartnerRawFromAPI, fetchCurrentPartners } from './actions';

type AdminState = {
  partners: PartnerRawFromAPI[];
  currentPartnersCursorNext: string | null;
};

const adminPartnersDataReducer = createReducer<PartnerRawFromAPI[]>(
  [],
  (builder) => {
    builder.addCase(fetchCurrentPartners.fulfilled, (_, action) => {
      return action.payload;
    });
  }
);

const adminReducer: (
  state: AdminState | undefined,
  action: Action
) => AdminState = (
  state = {
    currentPartnersCursorNext: null,
    partners: [],
  },
  action
) => {
  return {
    currentPartnersCursorNext: null,
    partners: adminPartnersDataReducer(state.partners, action),
  };
};

export default adminReducer;
